import { __, __image } from '@99designs/i18n';

export const OptionsData = (type: 'DesignLive' | 'Standard') => {
    switch (type) {
        case 'DesignLive':
            return {
                heroImage: __image('expert_services/SDP/Options/designLive/designlive-EN-US'),
                title: __('Schedule a live video call'),
                content: [
                    __(
                        'Fill out your design brief and schedule a 30 minute video call with a designer.'
                    ),
                    __('Once you’ve selected a time slot, we’ll email you a Zoom meeting link.'),
                    __(
                        'Your designer will review your design brief and create an initial design before your appointment.'
                    ),
                    __(
                        'During your call, you’ll get to see your design and provide feedback so changes can be made in real time.'
                    ),
                    __('You’ll also have up to three revisions available after your live session.'),
                ],
                inclusions: [
                    __('Work with your designer on a live call.'),
                    __('Review your design in real time.'),
                    __(
                        'Get designer support to choose print options and submit design for printing.'
                    ),
                    __('Fast turnaround.'),
                ],
            };
        case 'Standard':
            return {
                heroImage: __image('expert_services/SDP/Options/standard/standard-EN-US'),
                title: __('Review online in your own time'),
                content: [
                    __('Fill out your design brief and your designer will get to work.'),
                    __('We’ll send you an email once your design is ready for review.'),
                    __(
                        'Take your time to review your design and provide feedback via a written revision request.'
                    ),
                    __(
                        'Your designer will make your changes and provide you with an updated design incorporating your changes.'
                    ),
                    __('You’ll have up to three revisions available to make changes.'),
                ],
                inclusions: [
                    __('Share feedback through a revision request form.'),
                    __('Review your design in your own time.'),
                    __('Flexible turnaround.'),
                ],
            };
        default:
            throw new Error(`Invalid type: ${type}`);
    }
};
